import { jsLoadAnim, jsDeleteLoadAnim } from "../common/common";

document.getElementById('email-form').addEventListener('submit', async function (event) {
    event.preventDefault();

    const animTarget = document.getElementById('forget');
    jsLoadAnim(animTarget);

    const email = document.getElementById('input-email').value;

    try {
        const response = await fetch('/system/user/login/forget-pass-mailsend.php', {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
            },
            body: JSON.stringify({ email: email }), // JSON形式でメールアドレスを送信
        });
        const result = await response.json();
        if (result.success) {
            // 完了画面に遷移
            window.location.href = 'forgetpass_complete.html';
        } else {
            alert('送信に失敗しました');
            jsDeleteLoadAnim(animTarget);
        }

    } catch (error) {
        console.error('エラー:', error);
        document.getElementById('response').innerText = 'エラーが発生しました。';
        jsDeleteLoadAnim(animTarget);
    }
});